<template>
    <!-- 右边主体[[ -->
    <div class="freelance">
        <!-- 文本内容弹窗start -->
        <!-- 敏感内容检测弹窗start -->
        <div class="g-popup g-popup-transparent js-popup-sensitivity" style="display: block;" v-if="dirtyInfoDialog.show">
            <div class="popup-con sensitivity-popup">
                <div class="popup-close js-close-sensitivity"><i class="ico ico-close" @click="dirtyInfoDialog.show = false"></i></div>
                <h5 class="popup-title">敏感内容检测</h5>
                <div class="word">
                    标题中存在敏感词：<span class="color-theme">{{ dirtyInfoDialog.dirtyContent.title_dirty_words }}</span><br>
                    内容中存在敏感词：<span class="color-theme">{{ dirtyInfoDialog.dirtyContent.content_dirty_words}}</span>
                </div>
                <div class="pp-explain-inf g-scrollbar">
                    <div class="pp-explain-inf-con">
                        <div class="head">
                            <h4 class="name" v-html="dirtyInfoDialog.article.articleTitle"></h4>
                            <p class="author">{{ dirtyInfoDialog.article.creator}} <span class="time">{{ dirtyInfoDialog.article.created}}</span></p>
                        </div>
                        <p class="popup-text" v-html="dirtyInfoDialog.article.articleContent"></p>
                    </div>
                </div>
            </div>
            <!-- 敏感内容检测弹窗end -->
        </div>

        <!-- 相似度检测-文本内容弹窗start -->
        <div class="g-popup g-popup-transparent js-popup-similarity" style="display: none;">
            <div class="popup-con similarity-popup">
                <div class="popup-close js-close-similarity"><i class="ico ico-close"></i></div>
                <h5 class="popup-title">相似度检测</h5>
                <div class="similarity-cont f-fl">
                    <div class="head">
                        <h3 class="contrast">文本内容</h3>
                        <h4 class="name">新英雄米莱狄推塔碾压法师届但团战却怕小兵</h4>
                        <p class="author">小幽 <span class="time">2018/05/09</span></p>
                    </div>
                    <div class="pp-explain-inf g-scrollbar">
                        <div class="pp-explain-inf-con">
                            <p class="popup-text"><span class="color-theme">王者荣耀公孙离3技能能将敌人击退，接着3技能二段近身，</span>秒开2技能打出2技能的瞬间爆发伤害，然后平A打出被动的爆炸伤害，然后1技能拉开距离，接平A叠被动，在2技能2段还未消失前可以再按2技能移动到伞的位置迷惑敌人，再接上普攻打爆被动。</p>
                            <p class="popup-text">王者荣耀公孙离3技能能将敌人击退，接着3技能二段近身，秒开2技能打出2技能的瞬间爆发伤害，然后平A打出被动的爆炸伤害，然后1技能拉开距离，接平A叠被动，在2技能2段还未消失前可以再按2技能移动到伞的位置迷惑敌人，再接上普攻打爆被动。</p>
                            <div class="freelance-popup-img">
                                <img width="424" src="~Assets/img/pages/v4//freelance-01.png">
                            </div>
                        </div>
                    </div>
                </div>

                <div class="similarity-cont f-fr">
                    <div class="head">
                        <div class="g-status similarity-status">
                            <a class="arrow-left js-similarity-left" href="#"><i class="ico ico-arrow-left"></i></a>
                            <a class="arrow-right js-similarity-right" href="#"><i class="ico ico-arrow-right"></i></a>
                            <div class="swiper-container js-similarity-swiper">
                                <div class="swiper-wrapper js-tabs">
                                    <a class="swiper-slide active">
                                        <span class="label">相似内容1-80%</span>
                                    </a>
                                    <a class="swiper-slide">
                                        <span class="label">相似内容2-60%</span>
                                    </a>
                                    <a class="swiper-slide">
                                        <span class="label">相似内容3-40%</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <h4 class="name">新英雄米莱狄推塔碾压法师届但团战却怕小兵</h4>
                        <p class="author">小幽 <span class="time">2018/05/09</span></p>
                    </div>
                    <div class="pp-explain-inf g-scrollbar">
                        <div class="pp-explain-inf-con">
                            <div class="js-tabs-con">
                                <div class="con on">
                                    <p class="popup-text"><span class="color-theme">王者荣耀公孙离3技能能将敌人击退，接着3技能二段近身，</span>秒开2技能打出2技能的瞬间爆发伤害，然后平A打出被动的爆炸伤害，然后1技能拉开距离，接平A叠被动，在2技能2段还未消失前可以再按2技能移动到伞的位置迷惑敌人，再接上普攻打爆被动。</p>
                                    <p class="popup-text">王者荣耀公孙离3技能能将敌人击退，接着3技能二段近身，秒开2技能打出2技能的瞬间爆发伤害，然后平A打出被动的爆炸伤害，然后1技能拉开距离，接平A叠被动，在2技能2段还未消失前可以再按2技能移动到伞的位置迷惑敌人，再接上普攻打爆被动。</p>
                                    <div class="freelance-popup-img">
                                        <img width="424" src="~Assets/img/pages/v4//freelance-01.png">
                                    </div>
                                </div>
                                <div class="con">
                                    <p class="popup-text"><span class="color-theme">222 王者荣耀公孙离3技能能将敌人击退，接着3技能二段近身，</span>秒开2技能打出2技能的瞬间爆发伤害，然后平A打出被动的爆炸伤害，然后1技能拉开距离，接平A叠被动，在2技能2段还未消失前可以再按2技能移动到伞的位置迷惑敌人，再接上普攻打爆被动。</p>
                                    <p class="popup-text">王者荣耀公孙离3技能能将敌人击退，接着3技能二段近身，秒开2技能打出2技能的瞬间爆发伤害，然后平A打出被动的爆炸伤害，然后1技能拉开距离，接平A叠被动，在2技能2段还未消失前可以再按2技能移动到伞的位置迷惑敌人，再接上普攻打爆被动。</p>
                                    <div class="freelance-popup-img">
                                        <img width="424" src="~Assets/img/pages/v4//freelance-01.png">
                                    </div>
                                </div>
                                <div class="con">
                                    <p class="popup-text"><span class="color-theme">333 王者荣耀公孙离3技能能将敌人击退，接着3技能二段近身，</span>秒开2技能打出2技能的瞬间爆发伤害，然后平A打出被动的爆炸伤害，然后1技能拉开距离，接平A叠被动，在2技能2段还未消失前可以再按2技能移动到伞的位置迷惑敌人，再接上普攻打爆被动。</p>
                                    <p class="popup-text">王者荣耀公孙离3技能能将敌人击退，接着3技能二段近身，秒开2技能打出2技能的瞬间爆发伤害，然后平A打出被动的爆炸伤害，然后1技能拉开距离，接平A叠被动，在2技能2段还未消失前可以再按2技能移动到伞的位置迷惑敌人，再接上普攻打爆被动。</p>
                                    <div class="freelance-popup-img">
                                        <img width="424" src="~Assets/img/pages/v4//freelance-01.png">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 相似度检测-文本内容弹窗end -->
        </div>

        <!-- 相似度检测-视频内容弹窗start -->
        <div class="g-popup g-popup-transparent js-popup-video" style="display: none;">

            <div class="popup-con similarity-popup">
                <div class="popup-close js-close-video"><i class="ico ico-close"></i></div>
                <h5 class="popup-title">相似度检测</h5>
                <div class="similarity-cont f-fl">
                    <div class="head">
                        <h3 class="contrast">本视频</h3>
                        <h4 class="name">新英雄米莱狄推塔碾压法师届但团战却怕小兵</h4>
                        <p class="author">小幽 <span class="time">2018/05/09</span></p>
                    </div>
                    <div class="video">
                        <div class="video-id">唯一标识（MD5）:3665635664</div>
                        <div class="video-play">
                            <a class="ico ico-play" href="javascript:;"></a>
                            <div class="freelance-popup-img">
                                <img width="412" height="232" src="~Assets/img/pages/v4//freelance-01.png">
                            </div>
                        </div>
                    </div>
                </div>

                <div class="similarity-cont f-fr">
                    <div class="head">
                        <h3 class="contrast">相似视频-100%</h3>
                        <h4 class="name">新英雄米莱狄推塔碾压法师届但团战却怕小兵</h4>
                        <p class="author">今晚不吃鸡 <span class="time">2018/05/08</span></p>
                    </div>
                    <div class="video">
                        <div class="video-id">唯一标识（MD5）:3665635664</div>
                        <div class="video-play">
                            <a class="ico ico-play" href="javascript:;"></a>
                            <div class="freelance-popup-img">
                                <img width="412" height="232" src="~Assets/img/pages/v4//freelance-01.png">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 相似度检测-视频内容弹窗end -->
        </div>

        <!-- 驳回弹窗start -->
        <div class="g-popup g-popup-transparent js-popup-reject" style="display: block;" v-if="rejectDialog.show">
            <div class="popup-con reject-popup">
                <div class="popup-close js-close-reject"><i class="ico ico-close" @click="cancelReject"></i></div>
                <h5 class="popup-title">驳回理由</h5>
                <textarea class="textarea" name="" cols="" rows="6" placeholder="请输入驳回理由" v-model="rejectDialog.reason"></textarea>
                <p class="btn">
                    <a class="g-btn js-close-reject" href="javascript:;" @click="doRejectArticle">提交</a>
                    <a class="g-btn js-close-reject" href="javascript:;" @click="cancelReject">取消</a>
                </p>
            </div>
            <!-- 驳回弹窗end -->
        </div>

        <!-- 发布渠道信息弹窗start -->
        <div class="g-popup g-popup-transparent js-popup-channel" style="display: block;" v-if="mediaDistributeDialog.show">
            <div class="popup-con channel-popup">
                <div class="popup-close js-close-channel"><i class="ico ico-close" @click="mediaDistributeDialog.show = false"></i></div>
                <h5 class="popup-title">发布渠道信息</h5>
                <div class="channel-info">
                    <p class="list">
                        <label class="label">媒体</label>
                        {{ mediaDistributeDialog.mediaName }}
                    </p>
                    <p class="list">
                        <label class="label">账号</label>
                        {{ mediaDistributeDialog.accountName }}
                    </p>
                    <p class="list">
                        <label class="label">*封面图</label>
                        <img :src="mediaDistributeDialog.outCover" width="312" alt="">
                    </p>
                    <p class="list">
                        <label class="label">*标题</label>
                        {{ mediaDistributeDialog.outTitle }}
                    </p>
                    <p class="list">
                        <label class="label">*分类</label>
                        游戏
                    </p>
                </div>
            </div>
            <!-- 发布渠道信息弹窗end -->
        </div>

        <div class="g-content">
            <div class="g-status">
                <a class="arrow-left js-status-left" href="#" @click="swiperPrev"><i class="ico ico-arrow-left"></i></a>
                <a class="arrow-right js-status-right" href="#" @click="swiperNext"><i class="ico ico-arrow-right"></i></a>
                <div class="swiper-container" id="swiper-tab">
                    <div class="swiper-wrapper">
                        <!-- 交互说明：
                            选中样式：给p标签添加类 active
                         -->
                        <div class="swiper-slide" v-for="(item,index) in swiperItem" :key="item.id">
                            <div class="title" :class="{active: index == curTab}" @click="changeTab(index,item)">{{item.name}}<span class="num">（{{item.num}}）</span></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="search f-clearfix">
                <select-box :selectList="allGame" :itemTitle="'游戏'" :selected.sync="params.gameId"></select-box>
                <select-box :selectList="articleType" :itemTitle="'内容类型'" :selected.sync="params.type"></select-box>
                <div class="list contribute-time">
                    <p class="name">投稿时间</p>
                    <div class="g-select f-fl">
                        <!-- <p class="set">请选择投稿时间<i class="ico ico-calendar js-calendar-ico f-inlineblock-top"></i></p> -->
                        <el-date-picker style="width:200px;" v-model="dateVal" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" format="yy/MM/dd" value-format="yyyy-MM-dd" @change="onDateChange">
                        </el-date-picker>
                        <div class="picker-box">

                        </div>
                    </div>
                </div>
                <div class="list">
                    <p class="name"><label for="keyword">关键词</label></p>
                    <div class="g-select f-fl">
                        <input class="input" name="keyword" type="text" placeholder="请输入要搜索的关键词" v-model="params.title">
                    </div>
                </div>
                <div class="inquire">
                    <input class="btn" type="button" value="查询" @click="getList">
                </div>
            </div>
            <ul class="freelance-list">
                <li class="list-empty f-clearfix" v-if="!articleList.length">
                    <img src="~Assets/img/pages/v4/search-null.png" />
                </li>
                <li class="list f-clearfix" v-for="(article,index) in articleList" :key="index">
                    <div class="f-clearfix">
                        <p class="pic"><img :src="article.imgUrl" width="197" height="111" alt=""></p>
                        <div class="txt">
                            <!-- 交互说明：
                                文本内容弹窗：js-open-view
                                视频内容弹窗：js-open-view-video
                             -->
                            <h3 class="title"><span class="type">{{ getArticleType(article) }}</span>
                                <a class="name js-open-view" href="javascript:;" @click="previewArticle(article)">{{ article.articleTitle }}</a>
                                <span class="btn">原创</span>
                            </h3>
                            <div class="intro">
                                {{ article.gameName }}
                            </div>
                            <p class="author">{{ article.creator }} <span class="time">{{ article.created ? article.created.substr(0,10) : '' }}</span>
                            </p>
                        </div>
                        <div class="examine">

                            <p class="data">
                                <label class="label"></label>
                                <a class="link js-open-similarity" href="javascript:;"></a>
                                <!-- 交互说明：
                                    文本内容相似度弹窗：js-open-similarity
                                    视频内容相似度弹窗：js-open-video
                                 -->
                            </p>
                            <p class="data">
                                <label class="label">敏感词</label>
                                <a class="link js-open-sensitivity" href="javascript:;" @click="showDirtyInfoDialog(article)">{{ article.dirtyContent.dirtyStatusText }}</a>
                            </p>
                            <p class="data">
                                <label class="label">实时计费流量</label>
                                {{ article.totalFlow ? article.totalFlow : ''}}
                            </p>
                            <!-- 交互说明：
                                关闭样式：<i class="ico ico-down"></i>
                                展开样式：<i class="ico ico-up"></i>
                             -->
                            <a class="switch js-down" href="javascript:;" @click="article.showMediaDistribute = !article.showMediaDistribute">发布渠道
                                <i class="ico" :class="article.showMediaDistribute ? 'ico-up' : 'ico-down'"></i>
                            </a>
                        </div>
                        <div class="operation">
                            <div v-if="article.ugcProfitCheck == 2">
                                <p class="status">
                                    <span>
                                        {{ getArticleStatusText(article.ugcProfitCheck)}}
                                    </span>
                                </p>
                                <p class="btn">
                                    <!--供应商的验收操作-->
                                    <a class="g-btn" href="javascript:;" @click="publishArticle(article)">通过</a>
                                    <a class="g-btn js-open-reject" href="javascript:;" @click="rejectArticle(article)">驳回</a>
                                </p>
                            </div>
                            <div v-else-if="[3,5].includes(article.ugcProfitCheck)">
                                <p class="status status-pass">
                                    <span>
                                        {{ getArticleStatusText(article.ugcProfitCheck)}}
                                    </span>
                                </p>
                            </div>
                            <div v-else-if="[4,6].includes(article.ugcProfitCheck)">
                                <p class="status">
                                    <span>
                                        {{ getArticleStatusText(article.ugcProfitCheck)}}
                                    </span>
                                </p>
                                <div class="reject">
                                    <p class="info f-hide-col-4">{{ article.reject_remark }}</p>
                                    <p class="all"><i class="triangle"></i>{{ article.reject_remark }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- 交互说明：
                        同步成功样式：给.sync 添加类 sync-success，图标为 <i class="ico ico-success"></i>
                        同步失败样式：给.sync 添加类 sync-failure，图标为 <i class="ico ico-failure"></i>
                     -->
                    <ul class="channel f-clearfix js-channel-show" style="display: block" v-if="article.showMediaDistribute">
                        <li class="item" v-for="(media,index) in article.mediaDistribute" :key="index">
                            <span class="head"><img :src="media.outCover" width="25" height="25"></span>
                            <a class="name js-open-channel" href="javascript:;" @click="showMediaDistributeDialog(media)" @mouseenter="media.showRemark = true" @mouseleave="media.showRemark = false">{{ media.accountName }}</a>
                            <span class="sync sync-success" v-if="media.status==1">同步<i class="ico ico-success"></i></span>
                            <span class="sync sync-failure" v-else-if="media.status==0">未同步 <i class="ico ico-failure"></i></span>
                            <span class="sync sync-failure" v-else-if="media.status==3">同步失败<i class="ico ico-failure"></i></span>
                            <div class="sync-failure-reason" style="display: block" v-if="media.showRemark && media.remark">
                                <div class="sync-failure-triangle"></div>
                                <div class="failure-reason-text f-hide-col-1">{{media.remark}}</div>
                            </div>
                        </li>
                    </ul>
                </li>
            </ul>
            <!--无结果显示图标[[-->
            <div class="result-show-area no-data-show" style="display: none;">
                <div class="no-data-pic"></div>
            </div>
            <!--无结果显示图标]]-->

            <!-- loading [[ -->
            <!-- <div class="g-loading f-hide">
	        	<img src="../public/img/tgl-loding.gif"/>
	        	<p class="loading-text">
	        		<span class="loading-text-con">loading</span>
	        		<em class="spot spot-left"></em>
	        		<em class="spot spot-con"></em>
	        		<em class="spot spot-right"></em>
	        	</p>
	        </div> -->
            <!-- loading ]] -->

            <!-- 7.21 添加 每个tab内容都有个空数据 -->
            <!-- 空数据 start -->
            <!-- <div class="empty f-hide">
                <img class="empty-img" src="../public/img/radar-no-result.png"/>
            </div> -->
            <!-- 空数据 end -->

            <!-- 分页]] -->
            <pagination v-if="count>0" :total="count" :current-page.sync="params.pageIndex" :page-size="params.pageSize" @change="pageChange" ref="pager">
            </pagination>
        </div>

        <!--内容预览 start-->
        <content-preview ref="contentPreview"></content-preview>
        <video-preview ref="videoPreview"></video-preview>
        <!--内容预览 end-->
    </div>
    <!-- 右边主体]] -->
</template>
<style lang="scss" scoped>
@import "~Assets/vendor/swiper/swiper-3.2.7.min.css";
@import "~Assets/sass/pages/v4/check/freelance.scss";
.picker-box {
    height: 40px;
    display: inline-block;
    vertical-align: bottom;
    // width: 450px;
    /deep/ .full-jcalendar .input__inner {
        height: 40px;
        border: 0;
        border-bottom: 1px solid #ebebeb;
        &::-webkit-input-placeholder {
            font-weight: normal;
            font-size: 14px;
        }
    }
}
.g-content {
    min-height: 50rem;
}
.freelance .freelance-list .channel .name {
    width: 110px;
}
.freelance .freelance-list .channel .item {
    margin-bottom: 3px;
}
.freelance .freelance-list .examine .label {
    width: 90px;
}
.color-theme {
    color: #fd7e28;
}
.list-empty {
    width: 100%;
    text-align: center;
    height: 300px;
    margin-top: 50px;
}
</style>
<script>
import Swiper from 'Assets/vendor/swiper/swiper-3.2.7.min.js';
import pagination from 'Components/v4/pagination/pagination_v4';
import selectBox from 'Components/v4/dropdown/select_box';
import contentPreview from 'Components/v4/pop/content_preview';
import videoPreview from 'Components/v4/pop/video_preview';
import {
    AllGame, ugcApproveList, ugcApproveListStat, ugcArticlePublish, ugcArticleReject, ArticleDetail
} from 'Services/getData.js';
export default {
    data() {
        return {
            articleList: [],
            datePicker: {
                value: '',
                type: 'DATERANGE',
                showLunarClass: 'MIX',
                showBackYears: 2,
                showLunarico: false,
                showLunarControl: false,
                width1: '200',
                height: '40',
                format: 'YYYY.MM.DD',
                placeholder: '请输入日期',
                rangeSeparator: '-',
                disabled: false,
                editable: true,
                clearable: true,
                pickerOptions: {
                    disabledDate(time) {
                        return time.getTime() > Date.now();
                    }
                }
            },
            dateVal: [],
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now(); //这里就是设置当天后的日期不能被点击
                }
            },
            swiperItem: [
                {
                    name: '待验收', id: 2, num: 0
                },
                {
                    name: '供应商通过', id: 3, num: 0
                },
                {
                    name: '供应商驳回', id: 4, num: 0
                },
                {
                    name: '内容经理通过', id: 5, num: 0
                },
                {
                    name: '内容经理驳回', id: 6, num: 0
                }
            ], /*0非计费内容 1待达标 2未验收 3供应商验收通过 4供应商验收驳回 5内容经理验收通过 6内容经理验收驳回 7未达标*/
            mySwiper: '',
            curTab: 0,
            curTabId: 2,
            count: 0, //总记录数
            params: {
                pageSize: 10,
                pageIndex: 0,
                gameId: '',
                type: '',
                title: '',
                created: '' // 投稿时间
            },
            allGame: [],
            articleType: [
                {
                    name: '请选择', id: ''
                },
                {
                    name: "图文", id: 0
                },
                {
                    name: "视频", id: 1
                },
                {
                    name: "小说", id: 50
                },
                {
                    name: "漫画", id: 60
                }
            ],
            mediaDistributeDialog: {
                show: false,
                outTitle: '',
                outCover: '',
                accountName: '',
                mediaName: ''
            },
            rejectDialog: {
                articleId: '',
                show: false,
                reason: ''
            },
            dirtyInfoDialog: {
                show: false,
                dirtyContent: {},
                article: {}
            }
        }
    },
    components: {
        pagination, selectBox, contentPreview, videoPreview
    },
    mounted() {
        this.initSwiper();
        this.getAllGame();
        this.getList();
    },
    filters: {},
    methods: {
        getList() {
            this.getArticleList();
            this.getArticleListStat();
        },
        changeTab(index, tabItem) {
            if(index == this.curTab){
                return
            }
            this.count = 0;//切换tab时重置为零 让分页消失 间接实现刷新  解决pageIndex修改后 分页条没有刷新问题
            this.params.pageIndex = 0;//重置到第一页
            this.curTab = index;
            this.curTabId = tabItem.id;
            this.getArticleList();
            this.getArticleListStat();
        },
        onDateChange(choiceDate) {
            // this.property.beginTime = choiceDate[0];
            // this.property.endTime = choiceDate[1];
        },
        initSwiper() {
            this.mySwiper = new Swiper('#swiper-tab', {
                paginationClickable: true,
                slidesPerView: 'auto',
                initialSlide: 0,
                slideToClickedSlide: true,
                centeredSlides: true,
                onTransitionEnd: function (swiper) {
                    if (swiper.progress == 1) {
                        swiper.activeIndex = swiper.slides.length - 1
                    }
                }
            })
        },
        swiperPrev() {
            this.mySwiper.slidePrev();
        },
        swiperNext() {
            this.mySwiper.slideNext();
        },
        showMediaDistributeDialog(media) {
            this.mediaDistributeDialog = Object.assign({}, media, {
                show: true
            });
        },
        publishArticle(article) {
            this.$confirm('确认审核通过此内容').then(() => {
                this.doPublishArticle(article.id);
            }).catch(() => { });
        },
        previewArticle(article) {
            if (article.articleType === 0) {
                this.$refs.contentPreview.loadInfo(article.id, false, true);
            } else {
                this.$refs.videoPreview.remotePreview(article.id, false, true);
            }
        },
        rejectArticle(article) {
            this.rejectDialog.show = true;
            this.rejectDialog.articleId = article.id;
        },
        cancelReject() {
            this.rejectDialog = {
                show: false,
                articleId: '',
                reason: ''
            };
        },
        showDirtyInfoDialog(article) {
            this.dirtyInfoDialog.show = true;
            this.dirtyInfoDialog.dirtyContent = article.dirtyContent;
            this.getArticleDetail(article.id);
        },
        async getArticleDetail(id) {
            let response = await ArticleDetail(id);
            let result = response.data;
            
            if (response.status == 200 && result.code == 0) {
                let article = result.data;
                let dirtyContent = this.dirtyInfoDialog.dirtyContent;
                let tDirtyWord = dirtyContent.title_dirty_words && dirtyContent.title_dirty_words.split(',');
                let cDirtyWord = dirtyContent.content_dirty_words && dirtyContent.content_dirty_words.split(',');
                article.articleContent = article.articleContent && article.articleContent.replace(new RegExp(`(${cDirtyWord && cDirtyWord.join('|')})`, 'g'),
                    `<span style="color: #FD7E28">$1</span>`);
                article.articleTitle = article.articleTitle && article.articleTitle.replace(new RegExp(`(${tDirtyWord && tDirtyWord.join('|')})`, 'g'),
                    `<span style="color: #FD7E28">$1</span>`);
                this.dirtyInfoDialog.article = article;
            }else{
                this.dirtyInfoDialog.article  = {}
            }
        },
        async doPublishArticle(id) {
            let param = {
                articleId: id
            };
            let res = await ugcArticlePublish(param);
            if (res.status == 200 && res.data.code == 0) {
                this.$alert(res.data.data.msg);
                this.getList();
            }
        },
        async doRejectArticle() {
            if (!this.rejectDialog.reason) {
                alert('驳回原因不能为空~');
                return false;
            }
            this.rejectDialog.show = false;
            let param = this.rejectDialog;
            let res = await ugcArticleReject(param);
            if (res.status == 200 && res.data.code == 0) {
                this.$alert(res.data.data.msg);
                this.getList();
            }
        },
        async getArticleList() {
            // {status,gameId,qq,type,beginTime,endTime,title,pageSize,pageIndex}
            let queryTime = {};
            if (typeof this.dateVal != null) {
                queryTime = {
                    beginTime: this.dateVal && this.dateVal[0],
                    endTime: this.dateVal && this.dateVal[1]
                };
            }
            let param = Object.assign(this.params, {
                status: this.curTabId
            }, queryTime);
            let res = await ugcApproveList(param);
            let data = res.data;
            if (res.status == 200 && res.data.code == 0) {
                this.articleList = data.data.data.map((article) => {
                    article.showMediaDistribute = false;
                    if (article.mediaDistribute) {
                        article.mediaDistribute.map((media) => {
                            media.showRemark = false;
                            return media;
                        });
                    }
                    return article;
                });
                this.count = data.data.count;
            }
        },
        async getArticleListStat() {
            let res = await ugcApproveListStat();
            if (res.status == 200 && res.data.code == 0) {
                let data = res.data.data;
                this.swiperItem.filter((item) => {
                    switch (item.id) {
                    case 2:
                        item.num = data.checkNum;
                        break;
                    case 3:
                        item.num = data.sPassNum;
                        break;
                    case 4:
                        item.num = data.sRejectNum;
                        break;
                    case 5:
                        item.num = data.mPassNum;
                        break;
                    case 6:
                        item.num = data.mRejectNum;
                        break;
                    }
                    return item;
                });
            }
        },
        pageChange(param) {
            // this.params.pageSize = param.pageSize;
            this.params.pageIndex = param.pageIndex - 1;
            this.getList();
        },
        async getAllGame() {
            let res = await AllGame();
            if (res.status == 200 && res.data.code == 0) {
                this.allGame = res.data.data;
            }
        },
        getArticleStatusText(articleStatus) {
            let text = '';
            this.swiperItem.filter((item) => {
                if (item.id == articleStatus) {
                    text = item.name;
                }
            })
            return text;
        },
        getArticleType(item) {
            let type = ''
            switch (parseInt(item.articleType)) {
            case 0:
                type = '图文';
                break;
            case 1:
                type = '视频';
                break;
            case 50:
                type = '小说';
                break;
            case 60:
                type = '漫画';
                break;
            default:
                type = '其他';
                break;
            }
            return `【${type}】`;
        }
    }
}
</script>
